export const useIsMobile = (): boolean =>
  /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);

export type UserPlatform = 'ios' | 'android' | 'macos' | null;

export const useUserPlatform = (): UserPlatform => {
  const agent = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(agent)) return 'ios';
  if (/Android/i.test(agent)) return 'android';
  if (/Mac/i.test(agent) && navigator.maxTouchPoints > 1) return 'ios'; // iPadOS 13+
  if (/Macintosh|Mac OS X/i.test(agent)) return 'macos';
  return null; // Windows, Linux, or other desktop
};
